import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { first } from "rxjs/operators";
import { CitationService } from "src/app/services/citation.service";
import { WebConstants } from "src/app/util/web.constants";

@Component({
  selector: "app-citation-view-dialog",
  templateUrl: "./citation-view-dialog.component.html",
  styleUrls: ["./citation-view-dialog.component.scss"],
})
export class CitationViewDialogComponent implements OnInit {
  public pastActionObject: any = null;
  toastrService: any;
  citationData: any;

  constructor(
    public dialog: MatDialogRef<CitationViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,public citationService: CitationService  ) {}

  ngOnInit(): void {
    this.getCitationsByPayloadID(this.data);
  }

  getCitationsByPayloadID(payloadID): void {
    this.citationService
      .citationDataByPayloadID(payloadID)
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.citationData = response.data;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  closeDialog(): void {
    this.dialog.close();
  }
}
